// Stores action types used for redux
// TODO: define usage

export const ACTION_TYPE = "ACTION_TYPE";
export const ACTION_TYPE2 = "ACTION_TYPE2";
